import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';
import { Params } from '@angular/router';
import { PageControl } from '../objects/main';

@Injectable()

export class FormsService {

  constructor(private http: HttpClient) {
  }

  public postFormContact(params: FormFields | IContactBright) {
    return this.http.post(environment.apiURL + '/frontEndOpen/contact', params)
      .toPromise()
      .then(response => response)
      .catch(error => {
        return null;
      });
  }

  postSolutionContact(params: FormFields) {
    return this.http.post(environment.apiURL + '/frontEndOpen/supplierContact', params)
      .toPromise()
      .then(response => response)
      .catch(error => {
        return null;
      });
  }
}

export interface IContactBright {
  name: string,
  email: string,
  city: string,
  profile: string
}

export class FormFields {
  type: string;
  name: string;
  email: string;
  role: string;
  city: string;
  profile: string;
  cityId: string;
  company: string;
  message: string;
  supplierId: string;
  solutionId: string;
  optIn: boolean;
}

const IGNORED_KEY_NAMES = ['pageControl'];
const PAGE_CONTROL_KEY_NAMES = ['page', 'orderByField', 'orderDirection'];
const OBJECT_KEY_NAMES = [
  'search',
  'featuredIn',
  'impact',
  'time',
  'cost',
  'score',
  'indicatorId',
  'technology',
  'tags'
];
const NUMBER_KEY_NAMES = [
  'minCost',
  'maxCost',
  'minTime',
  'maxTime',
  'minImpact',
  'maxImpact',
  'minScore',
  'maxScore',
  'page'
];
const BOOLEAN_KEY_NAMES = [];

export class SolutionFilterHelper {
  search: string;
  featuredIn: Array<string> = [];

  country: string;
  impact: Array<string>;
  time: Array<string>;
  cost: Array<string>;
  score: Array<string>;
  indicatorId: string;

  minCost: Number = 0;
  maxCost: Number = 5;
  minTime: Number = 0;
  maxTime: Number = 5;
  minImpact: Number = 0;
  maxImpact: Number = 5;
  minScore: Number = 0;
  maxScore: Number = 5;
  technology: Array<string> = [];
  tags: Array<string> = [];
  limit: Number = 10;
  page: Number = 0;
  orderByField: string;
  orderDirection: string;
  pageControl: PageControl = new PageControl();

  toParamMap(): Params {
    const params: Params = {};
    Object.keys(this).forEach(k => {
      let value: any;
      if (OBJECT_KEY_NAMES.indexOf(k) >= 0) {
        value = JSON.stringify(this[ k ]);
      } else if (IGNORED_KEY_NAMES.indexOf(k) < 0) {
        value = this[ k ];
      }
      params[ k ] = value;
    });
    if (this.pageControl.page) {
      params.page = this.pageControl.page;
    }
    params.sortField = this.pageControl.orderField;
    params.sortDirection = this.pageControl.order;
    return params;
  }

  updateFromParamMap(params: Params): void {
    Object.keys(params).forEach(k => {
      let value: any;
      if (OBJECT_KEY_NAMES.indexOf(k) >= 0) {
        value = JSON.parse(params[ k ]);
      } else if (IGNORED_KEY_NAMES.indexOf(k) < 0) {
        value = params[ k ];
      }

      if (NUMBER_KEY_NAMES.indexOf(k) >= 0) {
        value = Number(value);
        if (value === Number.NaN) {
          value = undefined;
        }
      } else if (BOOLEAN_KEY_NAMES.indexOf(k) >= 0) {
        value = JSON.parse(value);
      }

      if (value !== undefined) {
        if (PAGE_CONTROL_KEY_NAMES.indexOf(k) >= 0) {
          if (k === 'page' && value > 0) {
            value--;
          }
          this.pageControl[ k ] = value;
        } else {
          this[ k ] = value;
        }
      }
    });
  }
}
